<template>
	<div class="content-wrapper">
		<div class="row">
			<div class="col-sm-12 col-md-6">
				<app-breadcrumb :page-title="`Schedule Recommendation - ${assignScheduleRowData?.invoice_id?.request_no}`" />
			</div>
			<div class="col-sm-12 col-md-6 breadcrumb-side-button">
				<div class="float-md-right mb-3 mb-sm-3 mb-md-0">
					<!-- <button
						type="button"
						class="btn btn-success btn-with-shadow"
						@click="exportAll"
					>
						{{ $t("export_all") }}
					</button> -->
					<!-- <button
						type="button"
						class="btn btn-primary btn-with-shadow"
						data-toggle="modal"
						@click="openAddEditModal"
					>
						{{ $t("add") }}
					</button> -->
				</div>
			</div>
		</div>
		<hr
			style="
				border-top: 2px solid black;
				font-weight: bold;
				margin-bottom: 20px !important;
			"
		/>
		<app-table :id="tableId" :options="options" @action="getListAction" />

		<!-- <app-add-modal
			v-if="isAddEditModalActive"
			:table-id="tableId"
			:selected-url="selectedUrl"
			@close-modal="closeAddEditModal"
		/> -->

		<schedule-recommendation-table-form
			v-if="isAddEditModalActive"
			:table-id="tableId"
			:form-id="formId"
			:row-data="rowData"
			:selected-url="selectedUrl"
			@close-modal="closeAddEditModal"
		/>

		<app-delete-modal
			v-if="deleteConfirmationModalActive"
			:preloader="deleteLoader"
			modal-id="demo-delete"
			@confirmed="confirmed"
			@cancelled="cancelled"
		/>
	</div>
</template>

<script>
import CoreLibrary from "../../../../../../../../core/helpers/CoreLibrary.js";
import { ScheduleRecommendationTableSchema } from "./ScheduleRecommendationTableSchema";
import { urlGenerator } from "../../../../../../../Helpers/AxiosHelper";
import {
	SCHEDULE_RECOMMENDATION,
} from "../../../../../../../Config/ApiUrl";

export default {
	extends: CoreLibrary,
	inject: ["eventHub"],
	name: "ScheduleRecommendationTable",
	mixins: [ScheduleRecommendationTableSchema],
	props: {
		assignScheduleRowData: {
			type: Object,
			default: () => {
				return {};
			},
		},
	},
	created() {
		this.options.columns = [...this.tableColumns, this.actionObj];
	},
	mounted() {
		this.eventHub.$on("studentAssignScheduleOnTabScheduleDeleted", () => {
			this.$hub.$emit("reload-" + this.tableId);
		});
		this.eventHub.$on("studentAssignScheduleSecondFormSuccessCreateData", () => {
			this.$hub.$emit("reload-" + this.tableId);
		});
	},
	methods: {
		/**
		 * for open add edit modal
		 */
		openAddEditModal() {
			this.isAddEditModalActive = true;
		},

		/**
		 * for close add edit modal
		 */
		closeAddEditModal() {
			$("#schedule-recommendation-table").modal("hide");
			this.isAddEditModalActive = false;
			this.reSetData();
		},

		/**
		 * $emit Form datatable action
		 */
		getListAction(rowData, actionObj, active) {
			this.rowData = rowData;

			if (actionObj.title == "Delete") {
				this.openDeleteModal();
			} else if (actionObj.title == this.$t("edit")) {
				this.selectedUrl = `${SCHEDULE_RECOMMENDATION}/${rowData.id}`;
				this.openAddEditModal();
			}
		},

		/**
		 * for open confirmation modal
		 */
		openDeleteModal() {
			this.deleteConfirmationModalActive = true;
		},

		/**
		 * confirmed $emit Form confirmation modal
		 */
		confirmed() {
			// let url = `${this.Endpoint}/${this.rowData.id}`;
			let url = `transaction/schedule-recommendation/${this.rowData.id}`;
			this.deleteLoader = true;
			this.axiosDelete(url)
				.then((response) => {
					this.deleteLoader = false;
					$("#demo-delete").modal("hide");
					this.cancelled();
					this.$toastr.s(response.data.message);
				})
				.catch(({ error }) => {
					// Trigger after error
				})
				.finally(() => {
					this.$hub.$emit("reload-" + this.tableId);
					this.eventHub.$emit(
						"studentScheduleRecommendationOnScheduleTabDeleted"
					);
				});
		},

		/**
		 * cancelled $emit Form confirmation modal
		 */
		cancelled() {
			this.deleteConfirmationModalActive = false;
			this.reSetData();
		},
		reSetData() {
			this.rowData = {};
			this.selectedUrl = "";
		},
		exportAll() {
			window.location.replace(urlGenerator(DATATABLE_EXPORT));
		},
	},
};
</script>
